import React, { useEffect, useState } from "react";
import { setToken } from "../audit/authState";  // 설계 v7 §4-3 래퍼

// ──────────────────────────────────────────────
// LoginSuccessPage.jsx — OAuth2 콜백 처리
// 레거시 login-success/page.tsx 포팅
// OAuth2 로그인 성공 후 토큰을 받아 저장하고 메인으로 이동
// ──────────────────────────────────────────────

const LoginSuccessPage = ({ API_BASE_URL, onLoginSuccess }) => {
  const [status, setStatus] = useState("처리 중...");

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/getToken`, {
          credentials: "include",
        });
        const data = await response.json();

        if (data.token) {
          setToken(data.token, "local");

          // OAuth2 로그인 처리
          const verifyRes = await fetch(`${API_BASE_URL}/api/auth/verify`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: data.token }),
          });
          const verifyData = await verifyRes.json();

          if (verifyData.success && verifyData.user) {
            localStorage.setItem("groupCode", verifyData.user.groupCode || "");
            localStorage.setItem("userId", verifyData.user.userId || "");

            // ?page=login-success 잔류 시 새로고침마다 이 화면을 다시 타므로 제거
            window.history.replaceState({}, "", "/");

            if (onLoginSuccess) {
              onLoginSuccess({
                groupCode: verifyData.user.groupCode,
                userId: verifyData.user.userId,
              });
            }
          } else {
            setStatus("로그인 정보를 확인할 수 없습니다.");
          }
        } else {
          setStatus("토큰을 받지 못했습니다.");
        }
      } catch (error) {
        console.error("OAuth2 login failed:", error);
        setStatus("OAuth2 로그인에 실패했습니다.");
      }
    };

    fetchToken();
  }, [API_BASE_URL, onLoginSuccess]);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        fontFamily:
          "'Malgun Gothic', '맑은 고딕', 'Pretendard Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          padding: "40px",
          borderRadius: "16px",
          background: "#fff",
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            margin: "0 auto 16px",
            border: "4px solid #e5e7eb",
            borderTopColor: "#2563eb",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <p style={{ fontSize: "16px", color: "#374151" }}>{status}</p>
      </div>
    </div>
  );
};

export default LoginSuccessPage;
